import React from 'react'
import axios from 'axios'
import _ from 'underscore'
import { LoaderCircle } from 'lucide-react'
import WhatsappComposer from './composer'
import DoNotContactWarning from '../do_not_contact_warning'
import store from '../../state/store'

class Whatsapper extends React.Component {
  
  constructor(props) {
    super(props)

    this.state = {
      whatsapp: props.whatsapp,
      templates: props.templates,
      template_name: props.template_name,
      whatsapp_window_open: props.whatsapp_window_open,
      loading: _.isEmpty(props.whatsapp)
    }
  }

  componentDidMount() {
    if (_.isEmpty(this.state.whatsapp)) {
      this.fetchContent()
    }
  }

  componentWillUnmount() {
    store.emit('ui:whatsapper:change', {
      whatsapp: this.state.whatsapp,
      templates: this.state.templates,
      template_name: this.state.template_name
    })
  }

  onChange = (whatsapp) => {
    this.setState({whatsapp: whatsapp})
  }

  onTemplateChange = (template_name) => {
    this.fetchContent({template_name: template_name})
  }

  onVariableChange = (key, value) => {
    let whatsapp = this.state.whatsapp

    if (whatsapp.toJS) {
      whatsapp = whatsapp.toJS()
    }

    let variables = whatsapp.variables
    variables[key] = value
    this.setState({whatsapp: whatsapp})
  }

  fetchContent = (params = {}) => {
    const getParams = {
      related_to_type: this.props.related_to_type,
      related_to_id: this.props.related_to_id,
      recipient_type: this.props.recipient_type,
      recipient_id: this.props.recipient_id,
      template_name: params.template_name || 'draft'
    }

    axios.get("/api/sales/whatsapps/new", {params: getParams})
    .then((response) => {
      this.setState({
        whatsapp: response.data.whatsapp,
        templates: response.data.templates,
        template_name: params.template_name || (response.data.whatsapp_window_open ? 'draft' : ''),
        whatsapp_window_open: response.data.whatsapp_window_open,
        do_not_contact: response.data.do_not_contact
      })
    })
    .catch((error) => {
      handleError(error)
    })
    .then(() => {
      this.setState({loading: false})
    })
  }

  onConfirm = () => {
    const params = {
      related_to_type: this.props.related_to_type,
      related_to_id: this.props.related_to_id,
      recipient_type: this.props.recipient_type,
      recipient_id: this.props.recipient_id,
      template_name: this.state.template_name,
      content: this.state.whatsapp.content,
      variables: this.state.whatsapp.variables
    }

    store.emit('ui:whatsapper:send', params)
  }

  render() {
    if (this.state.loading) {
      return (
        <section className="flex justify-center p-10">
          <LoaderCircle className="size-8 animate-spin text-muted-foreground"/>
        </section>
      )
    }

    return (
      <div className="p-6 pt-4">
        <DoNotContactWarning
          show={this.state.do_not_contact}
          contact={this.props.recipient_type === 'Tutor' ? 'tutor' : 'customer'}
          className="mb-4"
        />
        <WhatsappComposer
          key={this.state.template_name}
          whatsapp={this.state.whatsapp}
          templates={this.state.templates}
          template_name={this.state.template_name}
          whatsapp_window_open={this.state.whatsapp_window_open}
          onChange={this.onChange}
          onSend={this.onConfirm}
          onTemplateChange={this.onTemplateChange}
          onVariableChange={this.onVariableChange}
        />
      </div>
    )
  }
}

export default Whatsapper
